import React, { useMemo } from 'react';
import { useT } from '../i18n';

export default function VariantPicker({ variants, selected, onSelect }) {
  const t = useT();
  const typeLabels = useMemo(() => ({ softcover: t.softcover, hardcover: t.hardcover, digital: t.digital }), [t]);
  const active = (variants || []).filter(v => v.isActive);

  return (
    <div className="variant-picker">
      {active.map((v) => (
        <button
          key={v.sku}
          type="button"
          className={`variant-option ${selected === v.sku ? 'variant-selected' : ''}`}
          onClick={() => onSelect(v.sku)}
        >
          <span className="variant-type">{typeLabels[v.type] || v.type}</span>
          <span className="variant-price">
            {v.compareAtCents > v.priceCents && (
              <span className="price-was">{(v.compareAtCents / 100).toFixed(0)}{t.currency}</span>
            )}
            {(v.priceCents / 100).toFixed(0)}{t.currency}
          </span>
        </button>
      ))}
    </div>
  );
}
